/**
 * Returns the element closest in the parentNodes of the element
 * that matches the selector
 *
 * Copied from the MDN polyfill w/ modifications to appease flow
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 *
 * @param  {Element} Element
 * @param  {string} selector A selector to find in the parentNode tree
 * @return {?Element} The closest element in the parentNodes matching
 * the selector or null if none is found
 */
function elementClosest(element: Element, selector: string): Element | null | undefined {
  // Prefer the native implementation
  // @ts-expect-error
  if (Element.prototype.closest) return element.closest(selector);
  let currentElement: any = element;
  if (document.documentElement && !document.documentElement.contains(currentElement)) return null;

  do {
    if (currentElement.matches(selector)) return currentElement;
    currentElement = currentElement.parentElement || currentElement.parentNode;
  } while (currentElement && currentElement.nodeType === 1);

  return null;
}

export default elementClosest;
